import React, {useState} from 'react'
import 'codemirror/lib/codemirror.css'// base css
import 'codemirror/theme/material.css'//theme css
import 'codemirror/mode/xml/xml'// for html
import 'codemirror/mode/css/css'// for css
import 'codemirror/mode/javascript/javascript'// for javascript

import {Controlled as ControlledEditor} from 'react-codemirror2'// for controlling the editors
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faCompressAlt, faExpandAlt } from '@fortawesome/free-solid-svg-icons'


const Editor = (props) => {
    const {
        language,
        displayName,
        value,
        onChange
    } = props
    const [open, setOpen] = useState(true)
    function handleChange(editor, data, value){
        onChange(value)
    }
    return (
        <>
            <div className={`editor-container ${(open) ? '' : 'collapsed'}`}>
                <div className="editor-title">
                    {displayName}
                    <button
                        type="button"
                        className="expand-collapse-btn"
                        onClick = {() => setOpen(prevOpen => !prevOpen)}
                    >
                        <FontAwesomeIcon icon= {open ? faCompressAlt : faExpandAlt}/>

                    </button>
                </div>
                <ControlledEditor
                    onBeforeChange = {handleChange}
                    value={value}
                    className="code-mirror-wrapper"
                    options={{
                        lineWrapping: true,
                        lint: true,
                        mode: language,
                        theme: 'material',
                        lineNumbers: true
                    }}
                />
            </div>
        </>
    )
}

export default Editor
